import { Controller } from '@hotwired/stimulus';
import showToast from 'lib/toast_notification';

export default class extends Controller {
  static targets = ['deleteEventDialog'];

  static values = {
    domIdToRemove: String,
  };

  handleEventRemovalSubmit(event) {
    this.deleteEventDialogTarget.hide();
    this.removeToast = showToast('Deleting event...', { type: 'info', automaticallyRemoveToast: false });
  }

  handleEventRemovalSuccess() {
    const domIdToRemove = this.domIdToRemoveValue;
    const elementToRemove = document.getElementById(domIdToRemove);
    elementToRemove?.remove();
    this.removeToast();
    showToast('Event deleted successfully');
  }

  handleEventRemovalFailure() {
    this.removeToast();
    showToast('Event could not be deleted', { type: 'error' });
  }
}
